"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Balance_reporterAbi__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_stakeHouse",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_memberId",
                type: "bytes",
            },
            {
                internalType: "uint64",
                name: "_updatedActiveBalanceInGwei",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "_activationEpoch",
                type: "uint64",
            },
            {
                internalType: "uint64",
                name: "_finalisedEpoch",
                type: "uint64",
            },
            {
                components: [
                    {
                        internalType: "uint248",
                        name: "deadline",
                        type: "uint248",
                    },
                    {
                        internalType: "uint8",
                        name: "v",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "r",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "s",
                        type: "bytes32",
                    },
                ],
                internalType: "struct ETH2Validation.EIP712Signature",
                name: "_signatureMetadata",
                type: "tuple",
            },
        ],
        name: "balanceIncrease",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
class Balance_reporterAbi__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Balance_reporterAbi__factory = Balance_reporterAbi__factory;
Balance_reporterAbi__factory.abi = _abi;
